<form [formGroup]="certificateForm" (ngSubmit)="onSubmit()">
  <div class="container my-5">
    <div class="row justify-content-center">
      <div class="col-lg-8 col-md-10 col-sm-12">

        <div class="card shadow rounded-4">
          <div class="card-body p-4">

            <h4 class="text-center mb-4 fw-bold">Certificate Details</h4>

            <!-- Certificate Number -->
            <div class="mb-3">
              <div class="form-floating">
                <input type="text" class="form-control" id="rollNo" formControlName="rollNumber"
                  placeholder="Roll Number" [ngClass]="{'is-invalid': f.rollNumber.touched && f.rollNumber.invalid,
                  'is-valid': f.rollNumber.touched && f.rollNumber.valid}">
                <label for="rollNo">Enter Roll Number <span class="text-danger">*</span></label>
              </div>
              <div *ngIf="f.rollNumber.touched && f.rollNumber.invalid" class="text-danger small mt-1 ms-2">
                Roll number is required.
              </div>
            </div>

            <!-- Applicant Name -->
            <div class="mb-3">

              <div class="input-group floating-input-group has-validation">

                <!-- Prefix -->
                <select class="form-select prefix-select w-25" formControlName="namePrefix" [ngClass]="{
              'is-invalid': f.namePrefix.touched && f.namePrefix.invalid,
              'is-valid': f.namePrefix.touched && f.namePrefix.valid
            }">
                  <option value="" disabled selected></option>
                  <option value="Mr">Mr</option>
                  <option value="Ms">Ms</option>
                  <option value="Mrs">Mrs</option>
                  <option value="Dr">Dr</option>
                </select>

                <!-- Applicant Name -->
                <div class="form-floating flex-grow-1 w-75">
                  <input type="text" class="form-control" formControlName="applicantName" placeholder="Applicant Name"
                    [ngClass]="{
               'is-invalid': f.applicantName.touched && f.applicantName.invalid,
               'is-valid': f.applicantName.touched && f.applicantName.valid
             }">
                  <label>Applicant Name <span class="text-danger">*</span></label>
                </div>

              </div>

              <!-- Validation -->
              <div *ngIf="f.namePrefix.touched && f.namePrefix.invalid" class="text-danger small mt-1 ms-2">
                Prefix is required.
              </div>

              <div *ngIf="f.applicantName.touched && f.applicantName.invalid" class="text-danger small mt-1 ms-2">
                Applicant name is required.
              </div>

            </div>



            <!-- Certificate Name -->
            <div class="mb-3">
              <div class="form-floating">
                <input type="text" class="form-control" formControlName="courseDetails" placeholder="Course Details"
                  [ngClass]="{'is-invalid': f.courseDetails.touched && f.courseDetails.invalid,
                'is-valid': f.courseDetails.touched && f.courseDetails.valid}">
                <label>Enter Course Details <span class="text-danger">*</span></label>
              </div>
              <div *ngIf="f.courseDetails.touched && f.courseDetails.invalid" class="text-danger small mt-1 ms-2">
                Course details is required.
              </div>
            </div>

            <div class="mb-3">
              <div class="form-floating">
                <input type="date" class="form-control" formControlName="courseStartDate"
                  placeholder="Course Start Date" [ngClass]="{
               'is-invalid': f.courseStartDate.touched && f.courseStartDate.invalid,
               'is-valid': f.courseStartDate.touched && f.courseStartDate.valid
             }">
                <label>Course Start Date <span class="text-danger">*</span></label>
              </div>

              <div *ngIf="f.courseStartDate.touched && f.courseStartDate.invalid" class="text-danger small mt-1 ms-2">
                Course start date is required.
              </div>
            </div>

            <!-- Course End Date -->
            <div class="mb-3">
              <div class="form-floating">
                <input type="date" class="form-control" formControlName="courseEndDate" placeholder="Course End Date"
                  [ngClass]="{
               'is-invalid': f.courseEndDate.touched && f.courseEndDate.invalid,
               'is-valid': f.courseEndDate.touched && f.courseEndDate.valid
             }">
                <label>Course End Date <span class="text-danger">*</span></label>
              </div>

              <div *ngIf="f.courseEndDate.touched && f.courseEndDate.invalid" class="text-danger small mt-1 ms-2">
                Course end date is required.
              </div>
            </div>

            <!-- Issued Date -->
            <div class="mb-3">
              <div class="form-floating">
                <input type="date" class="form-control" formControlName="issueDate" placeholder="Issued Date" [ngClass]="{'is-invalid': f.issueDate.touched && f.issueDate.invalid,
                'is-valid': f.issueDate.touched && f.issueDate.valid}">
                <label>Certificate Issued Date <span class="text-danger">*</span></label>
              </div>
              <div *ngIf="f.issueDate.touched && f.issueDate.invalid" class="text-danger small mt-1 ms-2">
                Certificate issued date is required.
              </div>
            </div>

            <!-- Submit Button -->
            <div class="text-center">
              <button type="submit" class="btn btn-primary px-4">Submit</button>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</form>